import {
  faBiohazard,
  faDolly,
  faEye,
  faFile,
  faGasPump,
  faGear,
  faListCheck,
  faTruckDroplet,
  faVest,
  faWarning,
} from '@fortawesome/free-solid-svg-icons';

export const RESERVE_REASONS_ICONS = {
  BAG_SHOPPING: 'faDolly',
  BIOHAZARD: 'faBiohazard',
  FILE: 'faFile',
  GAS: 'faGasPump',
  FLUID: 'faTruckDroplet',
  VISU: 'faEye',
  ENGINE: 'faGear',
  VESTE: 'faVest',
  OTHER: 'faListCheck',
  WARNING: 'faWarning',
};

export const RESERVE_REASONS_ICONS_DISPLAY = {
  [RESERVE_REASONS_ICONS.BAG_SHOPPING]: faDolly,
  [RESERVE_REASONS_ICONS.BIOHAZARD]: faBiohazard,
  [RESERVE_REASONS_ICONS.FILE]: faFile,
  [RESERVE_REASONS_ICONS.GAS]: faGasPump,
  [RESERVE_REASONS_ICONS.FLUID]: faTruckDroplet,
  [RESERVE_REASONS_ICONS.VISU]: faEye,
  [RESERVE_REASONS_ICONS.ENGINE]: faGear,
  [RESERVE_REASONS_ICONS.VESTE]: faVest,
  [RESERVE_REASONS_ICONS.OTHER]: faListCheck,
  [RESERVE_REASONS_ICONS.WARNING]: faWarning,
};

export const RESERVE_REASONS_ICONS_DISPLAY_NAME = {
  [RESERVE_REASONS_ICONS.BAG_SHOPPING]: 'Sac',
  [RESERVE_REASONS_ICONS.BIOHAZARD]: 'Risque',
  [RESERVE_REASONS_ICONS.FILE]: 'Fichier',
  [RESERVE_REASONS_ICONS.GAS]: 'Essence',
  [RESERVE_REASONS_ICONS.FLUID]: 'Niveaux',
  [RESERVE_REASONS_ICONS.VISU]: 'Visuel',
  [RESERVE_REASONS_ICONS.ENGINE]: 'Moteur',
  [RESERVE_REASONS_ICONS.VESTE]: 'Accessoires',
  [RESERVE_REASONS_ICONS.OTHER]: 'Divers',
  [RESERVE_REASONS_ICONS.WARNING]: 'Important',
};

export const RESERVE_REASONS_ICONS_ARRAY = [
  RESERVE_REASONS_ICONS.BAG_SHOPPING,
  RESERVE_REASONS_ICONS.BIOHAZARD,
  RESERVE_REASONS_ICONS.FILE,
  RESERVE_REASONS_ICONS.GAS,
  RESERVE_REASONS_ICONS.FLUID,
  RESERVE_REASONS_ICONS.VISU,
  RESERVE_REASONS_ICONS.ENGINE,
  RESERVE_REASONS_ICONS.VESTE,
  RESERVE_REASONS_ICONS.OTHER,
  RESERVE_REASONS_ICONS.WARNING,
];
